import { render, staticRenderFns } from "./faceGather.vue?vue&type=template&id=3045d593&scoped=true"
import script from "./faceGather.vue?vue&type=script&lang=js"
export * from "./faceGather.vue?vue&type=script&lang=js"
import style0 from "./faceGather.vue?vue&type=style&index=0&id=3045d593&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3045d593",
  null
  
)

export default component.exports